import { gql } from '@apollo/client';

export const ORDER_ROUTE_MAPPINGS = gql`
    fragment OrderRouteMappings on order_route_mappings {
        mapping_id
        order_id
        route_id
        type
        created_at
        duplicate_override
    }
`;

// An order's route + that route's owner, newest mapping first, the order's own carrier, and whether its
// goods already sit on a returns manifest — used to decide whether the route-returns trigger owns a return's manifest. Internal
// routes have no carrier_id; their owner is shipper_id. Returns manifests are the INBOUND ones the
// returns flows create: route-linked, or EXCEPTION-sourced for orders with no route.
export const GET_ORDER_ROUTE_CARRIER = gql`
    query GetOrderRouteCarrier($order_id: uuid!) {
        order_route_mappings(where: { order_id: { _eq: $order_id } }, order_by: { created_at: desc }) {
            type
            route {
                route_id
                carrier_id
                shipper_id
            }
        }
        order: orders_by_pk(order_id: $order_id) {
            order_id
            carrier_id
        }
        returns_manifest_items: items(
            where: {
                order_id: { _eq: $order_id }
                manifests: {
                    manifest: {
                        type: { _eq: "INBOUND" }
                        _or: [{ route_id: { _is_null: false } }, { source: { _eq: "EXCEPTION" } }]
                    }
                }
            }
            limit: 1
        ) {
            item_id
        }
    }
`;
